import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProfileService } from 'src/app/pages/account/services/profile.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProfileTypeService } from 'src/app/core/services/profile-type-service.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UtilsService } from 'src/app/core/services/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogOkComponent } from 'src/app/core/components/dialog-ok/dialog-ok.component';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
@Component({
  selector: 'prgov-transaction-admin-profile-modal',
  templateUrl: './transaction-admin-profile-modal.component.html',
  styleUrls: ['./transaction-admin-profile-modal.component.scss']
})
export class TransactionAdminProfileModalComponent implements OnInit {
  profile: any = null;
  form: FormGroup;
  profileTypes: any = [];
  profileImage: string = 'assets/images/avatars/profile.jpg';

  // Camera properties
  @ViewChild('videoElement', { static: false }) videoElement: ElementRef;
  @ViewChild('canvasElement', { static: false }) canvasElement: ElementRef;
  private stream: MediaStream;
  isCameraActive = false;
  isCapturingPhoto = false;
  isUploadingPhoto = false;
  private isDestroyed = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public formBuilder: FormBuilder,
    public profileService: ProfileService,
    public matSnackBar: MatSnackBar,
    private profileTypeService: ProfileTypeService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private utilsService: UtilsService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private ls: LsHelperService,
    public accountService: AccountService,
  ) {
    this.profile = data;
    this.createForm();
    this.profileImage = 'assets/images/avatars/profile.jpg';
  }

  ngOnInit() {
    // this.patchForm();
    this.getProfileTypes();
    this.loadProfileImage(this.profile.PhotoIdFileName);
  }

  loadProfileImage(fileName: string) {
    this.profileImage = null;
    if (fileName) {
      this.authService.getFileByFileName(fileName, false).then((base64: string) => {
        this.profileImage = base64;
      }).catch((error: any) => {
        this.profileImage = 'assets/images/avatars/profile.jpg';
      });
    } else {
      this.profileImage = 'assets/images/avatars/profile.jpg';
    }
  }

  getProfileTypes() {
    // Cargar tipos de perfil
    this.profileTypeService.getProfileTypes().subscribe((res: any) => {
      this.profileTypes = this.profile.IsIndividual ? res.Data.profileTypeIndividual : res.Data.profileTypeEntity;
      this.patchForm();
    });
  }

  createForm() {
    if (this.profile.IsIndividual) {
      this.form = this.formBuilder.group({
        IsIndividual: [true],
        Name: ['', Validators.required],
        SecondName: [''],
        LastName: ['', Validators.required],
        SecondLastName: [''],
        ProfileTypeId: [null, Validators.required],

        Address: [null],
        Street1: [null],
        Street2: [null],
        CityId: [null],
        State: [null],
        PostalCode: [null],
        OtherStreet1: [null],
        OtherStreet2: [null],
        OtherCityId: [null],
        OtherState: [null],
        OtherPostalCode: [null],
        CountryId: [null],
        OtherCountryId: [null]
      });
    } else {
      this.form = this.formBuilder.group({
        IsIndividual: [false],
        Name: ['', Validators.required],
        ProfileTypeId: [null, Validators.required],

        Address: [null],
        Street1: [null],
        Street2: [null],
        CityId: [null],
        State: [null],
        PostalCode: [null],
        OtherStreet1: [null],
        OtherStreet2: [null],
        OtherCityId: [null],
        OtherState: [null],
        OtherPostalCode: [null],
        CountryId: [null],
        OtherCountryId: [null]
      });
    }
  }

  patchForm() {
    const address = {
      StreetAddress: this.profile.Street1,
      StreetAddress2: this.profile.Street2,
      MunicipioStreet: this.profile.CityId ? this.profile.CityId.toString() : '',
      PostalCode: this.profile.PostalCode,
      PostPlusFour1: '',
      PostalAddress: this.profile.OtherStreet1,
      PostalAddress2: this.profile.OtherStreet2,
      MunicipioPostal: this.profile.OtherCityId ? this.profile.OtherCityId.toString() : '',
      PPostalCode: this.profile.OtherPostalCode,
      PostPlusFour2: '',
      postalAsStreet: this.profile.Street1 === this.profile.OtherStreet1 ? true : false,
      State: this.profile.State ? this.profile.State.toString() : '',
      StatePostal: this.profile.OtherState ? this.profile.OtherState.toString() : '',
      Country: this.profile.CountryId ? this.profile.CountryId.toString() : '',
      CountryPostal: this.profile.OtherCountryId ? this.profile.OtherCountryId.toString() : ''
    };

    if (this.profile.IsIndividual) {
      this.form.patchValue({
        IsIndividual: this.profile.IsIndividual,
        Name: this.profile.Name,
        SecondName: this.profile.SecondName,
        LastName: this.profile.LastName,
        SecondLastName: this.profile.SecondLastName,
        Address: address,
        ProfileTypeId: this.profile.ProfileTypeId
      });
    } else {
      this.form.patchValue({
        IsIndividual: this.profile.IsIndividual,
        Name: this.profile.Name,
        Address: address,
        ProfileTypeId: this.profile.ProfileTypeId
      });
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  updateProfile() {
    const data = this.form.value;

    data.Street1 = data.Address.StreetAddress;
    data.Street2 = data.Address.StreetAddress2;
    data.CityId = data.Address.MunicipioStreet;
    data.State = data.Address.State;
    data.PostalCode = data.Address.PostalCode;
    data.OtherStreet1 = data.Address.PostalAddress;
    data.OtherStreet2 = data.Address.PostalAddress2;
    data.OtherCityId = data.Address.MunicipioPostal;
    data.OtherState = data.Address.StatePostal;
    data.OtherPostalCode = data.Address.PPostalCode;
    data.CountryId = data.Address.Country;
    data.OtherCountryId = data.Address.CountryPostal;

    this.profile = { ...this.profile, ...data };

    this.profileService
      .updateV2(this.profile)
      .then((response: any) => {
        if (response.Success) {
          this.dialogRef.close(true);
        }
      }, err => {
        console.log(err);
      });
  }

  // Camera functionality methods
  async openCamera() {
    try {
      // Request camera access
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 640 },
          height: { ideal: 480 },
          facingMode: 'user' // Use front camera
        }
      });

      // Show video element and start stream
      this.videoElement.nativeElement.srcObject = this.stream;
      this.videoElement.nativeElement.style.display = 'block';
      this.videoElement.nativeElement.hidden = false;
      this.isCameraActive = true;

      // Show capture button
      this.showCameraControls();

    } catch (error) {
      console.error('Error accessing camera:', error);

      // Siempre usar modo simulación en desarrollo
      this.simulateCamera();
    }
  }

  showCameraControls() {
    // Camera controls are now handled by Angular template with *ngIf="isCameraActive"
    // No need to create dynamic HTML since we're using Angular Material buttons
  }

  private simulateCamera() {
    // Crear un canvas con imagen simulada
    const canvas = document.createElement('canvas');
    canvas.width = 640;
    canvas.height = 480;
    const ctx = canvas.getContext('2d');

    // Dibujar fondo azul
    ctx.fillStyle = '#2196F3';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Agregar texto
    ctx.fillStyle = 'white';
    ctx.font = '24px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('Cámara Simulada', canvas.width / 2, canvas.height / 2 - 20);
    ctx.font = '16px Arial';
    ctx.fillText('Modo Desarrollo', canvas.width / 2, canvas.height / 2 + 10);
    ctx.fillText('Haz clic en "Capturar Foto"', canvas.width / 2, canvas.height / 2 + 40);

    // En lugar de usar captureStream, creamos una imagen estática
    // y la mostramos directamente en el video element
    const imageDataUrl = canvas.toDataURL('image/jpeg', 0.8);

    // Crear un video element temporal para simular el stream
    const tempVideo = document.createElement('video');
    tempVideo.src = imageDataUrl;
    tempVideo.loop = true;
    tempVideo.muted = true;
    tempVideo.autoplay = true;

    // Mostrar el canvas directamente en lugar del video
    this.videoElement.nativeElement.style.display = 'none';
    this.videoElement.nativeElement.hidden = true;

    // Mostrar el canvas como "video"
    const canvasElement = this.canvasElement.nativeElement;
    canvasElement.style.display = 'block';
    canvasElement.hidden = false;
    canvasElement.width = 640;
    canvasElement.height = 480;

    // Copiar el contenido del canvas temporal al canvas del componente
    const canvasCtx = canvasElement.getContext('2d');
    canvasCtx.drawImage(canvas, 0, 0);

    this.isCameraActive = true;
    this.showCameraControls();
  }

  capturePhoto() {
    if (!this.canvasElement) {
      return;
    }

    // Activar estado de carga
    this.isCapturingPhoto = true;
    console.log('isCapturingPhoto set to true - starting photo capture');

    const canvas = this.canvasElement.nativeElement;

    // Si estamos en modo simulación, el canvas ya tiene la imagen
    // Si estamos en modo real, capturamos del video
    if (this.isCameraActive && this.videoElement && this.videoElement.nativeElement.srcObject) {
      // Modo real: capturar del video
      const video = this.videoElement.nativeElement;
      const context = canvas.getContext('2d');

      // Set canvas size to match video
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      // Draw video frame to canvas
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
    }
    // En modo simulación, el canvas ya tiene la imagen correcta

    // Convert canvas to blob
    canvas.toBlob((blob) => {
      if (blob) {
        // Create file from blob
        const file = new File([blob], 'camera-photo.jpg', { type: 'image/jpeg' });

        // Upload the captured photo
        this.upload([file]);

        // No cerrar la cámara aquí, se cerrará después de la subida exitosa
      } else {
        // Si hay error al crear el blob, desactivar estado de carga
        this.isCapturingPhoto = false;
      }
    }, 'image/jpeg', 0.8);
  }

  closeCamera() {
    if (this.stream) {
      // Stop all tracks
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }

    // Hide video element
    if (this.videoElement) {
      this.videoElement.nativeElement.style.display = 'none';
      this.videoElement.nativeElement.hidden = true;
    }

    // Hide canvas element
    if (this.canvasElement) {
      this.canvasElement.nativeElement.style.display = 'none';
      this.canvasElement.nativeElement.hidden = true;
    }

    // Reset camera states
    this.isCameraActive = false;
    this.isCapturingPhoto = false;

    // Forzar la detección de cambios
    if (!this.isDestroyed) {
      try {
        this.cdr.detectChanges();
      } catch (error) {
        // Ignorar errores si la vista ya fue destruida
        console.log('View already destroyed, skipping detectChanges');
      }
    }
  }

  upload(files: File[], uploadingPhoto: boolean = false) {
    if (uploadingPhoto) {
      this.isUploadingPhoto = true;
    }

    if (files.length === 0) { return; }

		const isValid = this.utilsService.verifyFileExtension(files[0].name);

		if (isValid) {
			this.uploadAndProgress(files);
		} else {
			this.translate.get(['error.invalidExtension'])
				.subscribe(translations => {
					this.dialog.open(DialogOkComponent, {
						width: '250px',
						data: {
							msg: translations['error.invalidExtension']
						}
					});
				});

			return;
		}
	}

	uploadAndProgress(files: File[]) {
		const formData = new FormData();
		Array.from(files).forEach(f => formData.append('file', f));

		this.profileService.uploadImage(formData, this.profile.Id)
			.then((uploadedImage: string) => {
				// Recargar la imagen usando el nuevo método
				this.loadProfileImage(uploadedImage);

				// Cerrar la cámara y limpiar estados
				this.closeCamera();

				// Forzar la detección de cambios para asegurar que la UI se actualice
				this.cdr.detectChanges();

        this.isUploadingPhoto = false;
        this.isCapturingPhoto = false;
			}, err => {
        this.isUploadingPhoto = false;
        this.isCapturingPhoto = false;
      });
	}

}
